import React from 'react'

import { FloatingButton } from '@entur/button'
import { CommentIcon } from '@entur/icons'
import { Link } from '@entur/typography'

import './Feedback.scss'

type FeedbackProps = {
    isFooterFeedbackLink?: boolean
}

const Feedback: React.FC<FeedbackProps> = ({ isFooterFeedbackLink }) => {
    if (isFooterFeedbackLink) {
        return (
            <Link
                href="#"
                className="feedback-button"
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                }}
            >
                Give feedback
            </Link>
        )
    }

    return (
        <FloatingButton
            aria-label="Open Feedback Dialog"
            className="feedback-button"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault()
            }}
            style={{ position: 'fixed', bottom: '1em', right: '1em' }}
        >
            Feedback
            <CommentIcon color="white" />
        </FloatingButton>
    )
}

export default Feedback
